import Cookies from "js-cookie";

import { SELECTED_STORE } from "~/constants/user-cookies";

export const setStoreToCookies = (storeId: string): void => {
  Cookies.set(SELECTED_STORE, storeId, { expires: 30 });
};
